import React from "react"
import "./_style.scss"
import Table from "../../atoms/table/table"
import TableChart from "../../atoms/table/table-chart"
import TableToggleRows from "../../atoms/table/table-toggle-rows"

const XlsxDataTable = ({
  tableNotes,
  tableType,
  toggleType,
  tableData,
  tableID,
  skipYears,
	skip,
	showLines,
  noBackground,
  displayDanger,
	asteriskLabel,
	chartNotesBefore,
	chartNotesAfter,
  ...props
}) => {
  const compClassName = "xlsx-data-table"
  const compClass =
    props?.className !== undefined
      ? compClassName + " " + props?.className
      : compClassName

  return (
    <div comp={compClassName} className={compClass}>
      {tableData &&
        (tableType == "simple-data" || tableType == "progressbar") && (
          <Table {...{ tableData, tableType, toggleType, tableID, asteriskLabel }} />
        )}
      {tableData && tableType == "toggle-rows" && (
        <TableToggleRows {...{ tableData, tableType, toggleType, tableID }} />
      )}
      {tableData && tableType == "line-chart" && (
        <TableChart
          {...{
            tableData,
            tableType,
            toggleType,
            tableID,
            skipYears,
						skip,
						showLines,
            noBackground,
            displayDanger,
						asteriskLabel,
						chartNotesBefore,
						chartNotesAfter,
          }}
        />
      )}
    </div>
  )
}

export default XlsxDataTable
